import { createReducer, on } from "@ngrx/store";
import { DocViewerState } from "@store/doc-viewer/doc-viewer.state";
import { actionPanelActions } from "@store/doc-viewer/action-panel/action-panel.actions";

export const actionPanelReducer = createReducer<DocViewerState['currentActionPanelView']>(
	null,
	on(actionPanelActions.viewUpdated, (_state, {selectedView}) => {
		if(_state === selectedView) {
			return null;
		}
		return selectedView;
	}),
);
